import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Template } from "../typeDefs/templates";

export interface TemplateState {
	templates: Template[];
	loading: boolean;
}

const initialState: TemplateState = {
	templates: [],
	loading: false,
};

export const templatesSlice = createSlice({
	name: "templates",
	initialState,
	reducers: {
		setTemplates: (state, action: PayloadAction<Template[]>) => {
			state.templates = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setTemplates, setLoading } = templatesSlice.actions;

export default templatesSlice.reducer;
